import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";

type MultiRiskRemoveResponseType = ResponseType<null>;

function useRemoveMultiRiskMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<MultiRiskRemoveResponseType>["response"],
    AxiosResponseAndError<MultiRiskRemoveResponseType>["error"],
    string[]
  >({
    mutationFn: (data) =>
      ApiRequest.delete<MultiRiskRemoveResponseType>(
        `${requestURLs.risk}remove/multi`,
        { data: { riskIds: data } } // Assuming 'data' is an array
      ),
  });

  return mutation;
}

export default useRemoveMultiRiskMutation;
